const API_BASE_URL = process.env.REACT_APP_API_URL ?? '';

// Fire-and-forget by design: a failure here must never block or fail
// signup (the account is already created by the time this is called). Never
// throws — callers can await it purely to know whether it's worth a retry
// later, not as a gate on anything.
export async function acceptTerms(accessToken) {
  try {
    const res = await fetch(`${API_BASE_URL}/api/terms/accept`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    if (!res.ok) {
      console.error('[terms] acceptance write failed:', res.status);
      return false;
    }
    return true;
  } catch (err) {
    console.error('[terms] acceptance write failed:', err.message);
    return false;
  }
}
